const data = [
  {
    title:
      "Should you wait for iPhone 13 or Buy iPhone 12 in Hindi | iPhone 12 review",
    src: "https://www.youtube.com/embed/Z8QruAcklXo",
  },
  {
    title: "MacBook Air 2019 Full Review in Hindi | Pros and Cons |",
    src: "https://www.youtube.com/embed/D9L_1qMg8io",
  },
  {
    title: "Best Gaming laptop under 85000 ? |  MSI gl65 leopard gaming test |",
    src: "https://www.youtube.com/embed/cjN9d5kh1u8",
  },
  {
    title:
      "ONEPLUS killed SAMSUNG ? in Hindi | Oneplus 8 pro vs Samsung s20 plus in 2021",
    src: "https://www.youtube.com/embed/CMUt8iZ6N7s",
  },
  {
    title:
      "Don't buy Samsung S20 Plus in 2021 before watching this video  | Pros and Cons |",
    src: "https://www.youtube.com/embed/ZT-HFLNgkpw",
  },
  {
    title: "Oneplus 8 pro in 2021 ? in Hindi | Oneplus 8 pro long-term review",
    src: "https://www.youtube.com/embed/tB5Og3iIJHs",
  },
  {
    title: "Why not  buy the new iPad Pro 2021 ( Hindi ) | iPad Pro 2021",
    src: "https://www.youtube.com/embed/b47MWlWkwvM",
  },
  {
    title: "MacBook Air 2017 in 2021 ? ( Hindi ) | Long Term Review",
    src: "https://www.youtube.com/embed/b1cAh8vkYTY",
  },
  {
    title:
      "Don't Buy Samsung S20 FE 5g Before Watching This Video ( Hindi) | Pros and Cons",
    src: "https://www.youtube.com/embed/T9kmrfiZS7w",
  },
  {
    title: "Oneplus 9 vs Oneplus 8 pro 🔥 In Hindi",
    src: "https://www.youtube.com/embed/Z2Wi_ROWRxU",
  },
];

export default data;
